module.exports = __webpack_public_path__ + "static/img/menu_icon1.87777009.png";